import { test_remark_status_column_properties } from "../../HomePage/components/BacklogTable/utils/backlog_datagrid_common_column_properties";
import { Render_output_remarks_cell } from "./schedule_datagrid_cell_renderer";
import AnalystDropdown from "../components/AnalystDropdown";
import MachineDropdown from "../components/MachineDropdown";
import dayjs from "dayjs";

export const schedule_table_headers = {
  _id: {
    field: "_id",
    headerName: "ID",
    visible: false,
    width: 100,
  },
  product_code: {
    field: "product_code",
    headerName: "Product Code",
    visible: true,
    editable: false,
    width: 150,
  },
  test_id: {
    field: "test_name",
    headerName: "TEST NAME",
    visible: true,
    editable: false,
    width: 150,
  },
  spec_id: {
    field: "spec_id",
    headerName: "SPEC ID",
    visible: true,
    editable: false,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    // ]
  },
  qc_receive_date: {
    field: "qc_receive_date",
    headerName: "QC RECEIVE DATE",
    visible: true,
    editable: false,
    width: 150,
    // type: "date",
  },
  market: {
    field: "market",
    headerName: "MARKET",
    visible: true,
    editable: false,
    width: 150,
  },
  sample_type: {
    field: "sample_type",
    headerName: "MATERIAL TYPE",
    visible: true,
    editable: false,
    width: 200,
    // type: "singleSelect",
    // valueOptions: [
    //   ...sample_types
    // ]
  },
  pre_start_time: {
    field: "pre_start_time",
    headerName: "ANALYST START TIME",
    visible: true,
    width: 210,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },

  pre_end_time: {
    field: "pre_end_time",
    headerName: "ANALYST END TIME",
    visible: true,
    width: 210,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  machine_start_time: {
    field: "machine_start_time",
    headerName: "MACHINE START TIME",
    visible: true,
    width: 210,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
    renderCell: null,
  },
  machine_end_time: {
    field: "machine_end_time",
    headerName: "MACHINE END TIME",
    visible: true,
    width: 210,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },

  material_name: {
    field: "material_name",
    headerName: "Product Name",
    visible: true,
    editable: false,
    width: 150,
  },
  batch_no: {
    field: "batch_no",
    headerName: "BATCH ID",
    visible: true,
    editable: false,
    width: 100,
  },

  stp_id: {
    field: "stp_id",
    headerName: "STP ID",
    visible: true,
    editable: false,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FT007296", value: "FT007296" },
    //   { label: "FT003572", value: "FT003572" },
    //   { label: "FT003702", value: "FT003702" },
    //   { label: "FT005640", value: "FT005640" },
    //   { label: "FT010562", value: "FT010562" },
    //   { label: "FT006061", value: "FT006061" },
    //   { label: "FT008844", value: "FT008844" },
    //   { label: "FT010888", value: "FT010888" },
    // ]
  },

  // "step_name": {
  //   field: "step_name",
  //   headerName: "STEP NAME",
  //   visible: true,
  //   editable: false,
  //   width: 250,
  // },
  analyst_id: {
    field: "analyst_id",
    headerName: "ANALYST ID",
    visible: true,
    editable: false,
    width: 100,
    renderCell: (props) => <AnalystDropdown {...props} />,
  },
  machine_id: {
    field: "machine_id",
    headerName: "MACHINE ID",
    visible: true,
    editable: false,
    width: 100,
    renderCell: (props) => <MachineDropdown {...props} />,
    // type: "singleSelect",
    // valueOptions: [...machine_list]
  },
  non_critical_machines: {
    field: "non_critical_machines",
    headerName: "NON CRITICAL MACHINES",
    visible: true,
    editable: false,
    width: 550,
    // renderCell: (props) => <NonCriticalMachines {...props} />,
    // type: "singleSelect",
    // valueOptions: [...machine_list]
  },

  status: {
    field: "status",
    headerName: "STATUS",
    visible: true,
    editable: false,
    width: 150,
    ...test_remark_status_column_properties,
    renderCell: Render_output_remarks_cell,
  },
  // "qc_review": {
  //   field: "qc_review",
  //   headerName: "QC REVIEW",
  //   visible: true,
  //   editable: false,
  //   width: 100,
  //   renderCell: (props) => {
  //     return <Chip label="Pending" />;
  //   }
  // // },
  remark: {
    field: "remark",
    headerName: "REMARKS",
    visible: true,
    editable: false,
    width: 200,
    // ...remark_status_column_properties,
  },
};

export const static_completed_table_headers = {
  _id: {
    field: "_id",
    headerName: "ID",
    visible: false,
    width: 100,
  },
  product_code: {
    field: "product_code",
    headerName: "Product Code",
    visible: true,
    editable: false,
    width: 150,
  },
  test_id: {
    field: "test_name",
    headerName: "TEST NAME",
    visible: true,
    editable: false,
    width: 150,
  },
  spec_id: {
    field: "spec_id",
    headerName: "SPEC ID",
    visible: true,
    editable: false,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    // ]
  },
  qc_receive_date: {
    field: "qc_receive_date",
    headerName: "QC RECEIVE DATE",
    visible: true,
    editable: false,
    width: 150,
    // type: "date",
  },
  market: {
    field: "market",
    headerName: "MARKET",
    visible: true,
    editable: false,
    width: 150,
  },
  sample_type: {
    field: "sample_type",
    headerName: "MATERIAL TYPE",
    visible: true,
    editable: false,
    width: 200,
    // type: "singleSelect",
    // valueOptions: [
    //   ...sample_types
    // ]
  },
  pre_start_time: {
    field: "pre_start_time",
    headerName: "ANALYST START TIME",
    visible: true,
    width: 200,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },

  pre_end_time: {
    field: "pre_end_time",
    headerName: "ANALYST END TIME",
    visible: true,
    width: 200,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  machine_start_time: {
    field: "machine_start_time",
    headerName: "MACHINE START TIME",
    visible: true,
    width: 150,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  machine_end_time: {
    field: "machine_end_time",
    headerName: "MACHINE END TIME",
    visible: true,
    width: 150,
    // type: "dateTime",
    editable: false,
    valueGetter: ({ value }) => {
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  material_name: {
    field: "material_name",
    headerName: "Product Name",
    visible: true,
    editable: false,
    width: 150,
  },
  batch_no: {
    field: "batch_no",
    headerName: "BATCH ID",
    visible: true,
    editable: false,
    width: 100,
  },

  stp_id: {
    field: "stp_id",
    headerName: "STP ID",
    visible: true,
    editable: false,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FT007296", value: "FT007296" },
    //   { label: "FT003572", value: "FT003572" },
    //   { label: "FT003702", value: "FT003702" },
    //   { label: "FT005640", value: "FT005640" },
    //   { label: "FT010562", value: "FT010562" },
    //   { label: "FT006061", value: "FT006061" },
    //   { label: "FT008844", value: "FT008844" },
    //   { label: "FT010888", value: "FT010888" },
    // ]
  },

  // "step_name": {
  //   field: "step_name",
  //   headerName: "STEP NAME",
  //   visible: true,
  //   editable: false,
  //   width: 250,
  // },
  analyst_id: {
    field: "analyst_id",
    headerName: "ANALYST ID",
    visible: true,
    editable: false,
    width: 100,
  },
  machine_id: {
    field: "machine_id",
    headerName: "MACHINE ID",
    visible: true,
    editable: false,
    width: 100,
    // type: "singleSelect",
    // valueOptions: [...machine_list]
  },
  non_critical_machines: {
    field: "non_critical_machines",
    headerName: "NON CRITICAL MACHINES",
    visible: true,
    editable: false,
    width: 550,
    // renderCell: (props) => <NonCriticalMachines {...props} />,
    // type: "singleSelect",
    // valueOptions: [...machine_list]
  },

  status: {
    field: "status",
    headerName: "STATUS",
    visible: true,
    editable: false,
    width: 120,
    ...test_remark_status_column_properties,
  },
  // "qc_review": {
  //   field: "qc_review",
  //   headerName: "QC REVIEW",
  //   visible: true,
  //   editable: false,
  //   width: 100,
  //   renderCell: (props) => {
  //     return <Chip label="Pending" />;
  //   }
  // // },
  remark: {
    field: "remark",
    headerName: "REMARKS",
    visible: true,
    editable: false,
    width: 200,
    // ...remark_status_column_properties,
  },
};
